import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../Hook/AuthProvider";
import Onboarding from "./OnbordingProcess";
import { ROUTES } from "../constants/routes";

const ProtectedRoute = ({ children, isUnprotectedPage }) => {
  const { isAuthenticated, profileData, isInitialized } = useContext(AuthContext);
  const location = useLocation();

  // Handle referral code capture and redirection
  if (isInitialized && location.pathname === "/referral") {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    if (code) {
      localStorage.setItem("referralCode", code);
    }
    return <Navigate to={ROUTES.CHAT} replace />;
  }

  if (!isInitialized) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  // When coming from the mobile app (?source=app)
  const isFromApp = new URLSearchParams(location.search).get("source") === "app";
  if (isFromApp && location.pathname !== "/logged-out") {
    if (isAuthenticated && !sessionStorage.getItem("app_source_initialized")) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      sessionStorage.setItem("app_source_initialized", "1");
      return <Navigate to={`/login${location.search}`} replace />;
    }
  }

  // For unprotected pages, allow access without authentication
  if (isUnprotectedPage) {
    // If user is authenticated and trying to access unprotected pages (like / or /login), redirect to /dashboard
    if (isAuthenticated) {
      return <Navigate to={ROUTES.DASHBOARD} replace />;
    }

    return children;
  }

  // For protected pages, require authentication
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user needs onboarding
  if (profileData && !profileData.has_seen_onboarding) {
    return <Onboarding />;
  }

  return children;
};

export default ProtectedRoute;
